/**
 * Browser capability detection for the dual-path Secure Information File save flow.
 *
 * Chrome/Edge (File System Access API available) → silent auto-save via saveToHandle().
 * Safari/Firefox (no API) → persistent amber banner + manual download via triggerDownload().
 */

import { supportsFileSystemAccess } from "@/lib/secure-file";

export type BrowserCategory = "chrome-edge" | "safari-firefox" | "unknown";

export { supportsFileSystemAccess };

/**
 * Returns which save path to use for the current browser.
 * "chrome-edge"    → File System Access API available; silent auto-save.
 * "safari-firefox" → No File System Access API; download + amber banner.
 * "unknown"        → Non-browser environment (SSR / test with no window).
 */
export function detectBrowserCategory(): BrowserCategory {
  if (typeof window === "undefined") return "unknown";
  return supportsFileSystemAccess() ? "chrome-edge" : "safari-firefox";
}
